import { ChangeEvent } from "react";

export function validateFile(event: ChangeEvent<HTMLInputElement>) {
    const files = event.target.files
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf']

    if (files) {
        const filesArray = Array.from(files)
        const allFilesValid = filesArray.every(file => validTypes.includes(file.type))

        if (!allFilesValid) {
            alert('Por favor, envie apenas arquivos nos formatos JPG, PNG, GIF ou PDF.')
            event.target.value = ''
            return null
        } else {
            return filesArray
        }
    }

    return null
}

